const getOrderLineDosFrom1 = ({ orderLine, value, index }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (index !== undefined) {
    const indexOrderLine = orderLine ? orderLine[index] : null;
    if (indexOrderLine) {
      const date = indexOrderLine['Date of Service From'] || indexOrderLine.dateOfServiceFrom;
      return date.replace(/[/]/g, '').substring(0, 2);
    }

    return null;
  }
  return orderLine
    ? orderLine.map((item) => {
      const date = item['Date of Service From'] || item.dateOfServiceFrom;
      return date.replace(/[/]/g, '').substring(0, 2);
    }).join(', ')
    : null;
};

export default getOrderLineDosFrom1;



// WEBPACK FOOTER //
// ./src/utils/print/getOrderLineDosFrom1.js